import React from 'react';
import { ASSET_URL } from '../../../../env/Configurations';
import './Button-with-Icon-Preview.scss';

const ButtonWithIconPreview = (props) => {
  const { config } = props;
  return (
    <div className='button-with-icon'>
      <div className='preview-title'>{config?.titleH2 ? config?.titleH2 : 'H2 Title'}</div>
      {config?.button?.map((button, buttonIndex) => (
        <div
          style={{
            backgroundColor: config.backgroundColor,
            borderColor: config.backgroundColor !== '#ffffff' ? config.backgroundColor : '#707070',
          }}
          class={button.buttonTitle ? 'row button-title-value' : 'row button-empty'}
          key={buttonIndex}
        >
          {!button?.leftIconHide ? (
            <div class='col col-wrapper'>
              <div
                className={button?.leftIconImgURL ? '' : 'button-wrapper-icon-div'}
                style={{
                  backgroundImage: 'url(' + ASSET_URL + button?.leftIconImgURL + ')',
                  backgroundSize: 'cover',
                  height: '20px',
                  width: '20px',
                }}
              ></div>
            </div>
          ) : (
            <div class='col ps-0 pe-0 col-wrapper'>
              <div className='default-button-wrapper-icon-div' />
            </div>
          )}
          <div class='col-6 button-wrapper-icon-div-title'>
            {button?.buttonTitle || 'BUTTON TITLE'}
          </div>
          {!button?.rightIconHide ? (
            <div class='col col-wrapper-right'>
              <div
                className={button?.rightIconImgURL ? '' : 'button-wrapper-icon-div-right'}
                style={{
                  backgroundImage: 'url(' + ASSET_URL + button?.rightIconImgURL + ')',
                  backgroundSize: 'cover',
                  height: '20px',
                  width: '20px',
                }}
              ></div>
            </div>
          ) : (
            <div class='col pe-0 col-wrapper-right'>
              <div className='default-button-wrapper-icon-div-right' />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ButtonWithIconPreview;
